export default "__VITE_ASSET__D0P1AOPT__"